export default class RedeSocial {
  public id_rede_social: number;
  public url: string;
  public nome: string;
}
